import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { palette } from "../../theme/palette";
import { typography } from "../../theme/typography";
import styled from "@emotion/styled";
import classNames from "classnames";
const StyledLabel = styled.label(({ style, size, disabled }) => ({
    ...typography[size === "extraSmall"
        ? "Content.Caption02"
        : size === "small"
            ? "Content.Subtitle04"
            : size === "medium"
                ? "Content.Subtitle03"
                : "Content.Subtitle02"],
    color: disabled ? palette.grey030 : palette.grey070,
    whiteSpace: "nowrap",
    ...style,
}));
const StyledRequired = styled.span(() => ({
    color: palette.red050,
    marginLeft: "2px",
}));
export function GrLabel({ text, required, className, ...props }) {
    return (_jsxs(StyledLabel, { className: classNames("GrLabel", className), ...props, children: [text, required && _jsx(StyledRequired, { children: "*" })] }));
}
//# sourceMappingURL=GrLabel.js.map